jQuery(($) => {
	// Au scroll faire apparaitre ou disparaitre le bouton de retour en haut de page
	$(window).on('scroll', () => {
		const $back = $('.back-to-top')
		const duration = 600
		const posScroll = $(document).scrollTop()

		if (posScroll >= 550) {
			$back.fadeIn(duration)
		} else {
			$back.fadeOut(duration)
		}
	})

	$('.back-to-top').on('click', (event) => {
		event.preventDefault()
		$('html, body').animate({scrollTop: 0}, 500)
	})

	$('.menu_footer2').each(function (){
		$(this).find('li:nth-child(3n)').each(function () {
			$(this).nextAll('li').wrapAll('<div class="second"></div>');
			$(this).prevAll('li').andSelf().wrapAll('<div class="first"></div>');
		})
	})

	// CONTACT FORM
	$('.contact-form #jform_contact_email_copy-lbl').parent().parent().addClass('email-copy');

	$validate = $('.contact-form .validate');
	$validate.prop("disabled", true);
	$('#declaration').on('change', function() {
		if($(this).is(':checked')) {
			$validate.prop("disabled", false);
		}
		else {
			$validate.prop("disabled", true);
		}
	})
})
